import React, { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { postApi } from "../../services/apiController"; // Adjust the import path accordingly

const CustomizedForm = ({ name }) => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const initialValues = {
    name: "",
    email: "",
    mob_no: "",
    date: "",
    message: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    mob_no: Yup.string().required("Phone number is required"),
    date: Yup.date().required("Booking date is required"),
    message: Yup.string(),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const formattedValues = {
        ...values,
        date: dayjs(values.date).format("DD/MM/YYYY"), // Format date here
      };
      const res = await postApi("postQuery", formattedValues);
      toast.success(res.message);
      resetForm();
      setFormSubmitted(true); // Set formSubmitted to true to show the popup
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container mt-14 md:w-1/2 w-full p-2 mx-auto py-10">
      <h2 className="text-2xl mb-4 text-[#5b53fb] font-bold">{name}</h2>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isValid, dirty }) => (
          <Form className="bg-gray-50 p-6 rounded-lg shadow-md space-y-4">
            <div>
              <label htmlFor="name" className="block font-medium text-gray-700">
                Name
              </label>
              <Field
                type="text"
                name="name"
                id="name"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your name"
              />
              <ErrorMessage
                name="name"
                component="p"
                className="text-red-500 text-sm mt-1"
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block font-medium text-gray-700"
              >
                Email
              </label>
              <Field
                type="email"
                name="email"
                id="email"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your email"
              />
              <ErrorMessage
                name="email"
                component="p"
                className="text-red-500 text-sm mt-1"
              />
            </div>
            <div>
              <label
                htmlFor="phone"
                className="block font-medium text-gray-700"
              >
                Phone
              </label>
              <Field
                type="tel"
                name="mob_no"
                id="phone"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your phone number"
              />
              <ErrorMessage
                name="mob_no"
                component="p"
                className="text-red-500 text-sm mt-1"
              />
            </div>
            <div>
              <label htmlFor="date" className="block font-medium text-gray-700">
                Booking Date
              </label>
              <Field
                type="date"
                name="date"
                id="date"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <ErrorMessage
                name="date"
                component="p"
                className="text-red-500 text-sm mt-1"
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block font-medium text-gray-700"
              >
                Message
              </label>
              <Field
                as="textarea"
                name="message"
                id="message"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your message or inquiries"
              />
              <ErrorMessage
                name="message"
                component="p"
                className="text-red-500 text-sm mt-1"
              />
            </div>
            <button
              type="submit"
              className={`w-full bg-[#5b53fb] text-white p-3 rounded-lg font-bold hover:bg-blue-700 transition ${
                !(isValid && dirty) ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={!(isValid && dirty)}
            >
              Submit Inquiry
            </button>
          </Form>
        )}
      </Formik>

      {formSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-500">
          <div className="bg-white p-8 rounded-lg shadow-lg transform scale-95 transition-transform duration-500">
            <div className="flex flex-col items-center">
              <div className="text-[#5b53fb]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-16 w-16 animate-bounce"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm2-11a1 1 0 00-2 0v3a1 1 0 00.293.707l2 2a1 1 0 101.414-1.414L12 10.586V7z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <p className="text-2xl font-bold text-[#5b53fb] mt-4">
                Thank You!
              </p>
              <p className="text-gray-600 mt-2 text-center">
                Your inquiry has been submitted. We’ll get in touch with you
                shortly.
              </p>
              <button
                onClick={() => setFormSubmitted(false)}
                className="mt-6 bg-[#5b53fb] text-white px-6 py-2 rounded-lg font-bold shadow-md hover:bg-[#4b45f4] transition-all transform hover:scale-105 focus:outline-none"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomizedForm;
